import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FormErrorCodes = {
  FormCreateFailed: {
    code: 'form/create-failed',
    explanation:
      'Ocorreu um erro desconhecido ao tentar criar o formulário. Verifique suas informações e tente novamente.',
    localizations: {},
    message: 'Erro ao criar o formulário.',
  },
  FormDeleteFailed: {
    code: 'form/delete-failed',
    explanation:
      'Ocorreu um erro ao tentar excluir o formulário. Verifique suas informações e tente novamente.',
    localizations: {},
    message: 'Erro ao excluir o formulário.',
  },
  FormInvalidRegex: {
    code: 'form/invalid-regex',
    explanation:
      'A expressão regular fornecida no formulário é inválida. Campos que suportam validação por regex exigem uma expressão válida.',
    localizations: {},
    message: 'A expressão regular informada é inválida.',
    supportingDocs: [
      {
        name: 'Formulário',
        path: '/wiki/docs/pipe/forms#texto-curto',
      },
    ],
  },
  FormNotFound: {
    code: 'form/not-found',
    explanation: 'O formulário que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'Formulário não encontrado.',
  },
  FormUpdateFailed: {
    code: 'form/update-failed',
    explanation:
      'Ocorreu um erro ao tentar atualizar o formulário. Verifique suas informações e tente novamente.',
    localizations: {},
    message: 'Erro ao atualizar o formulário.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'form'>;

export const StageCardFormErrorCodes = {
  StageCardFormStageNotHaveForm: {
    code: 'stage-card-form/stage-not-have-form',
    explanation: 'A etapa do card não possui um formulário associado.',
    localizations: {},
    message: 'Esta etapa não possui um formulário associado.',
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'stage-card-form'>;

export const StageFormErrorCodes = {
  StageFormEmailNotFound: {
    code: 'stage-form/email-not-found',
    explanation:
      'O e-mail associado ao formulário da etapa não foi encontrado. Isso pode acontecer em formulários públicos.',
    localizations: {},
    message: 'O e-mail associado ao formulário não foi encontrado.',
  },
  StageFormLinkAlreadyAnswered: {
    code: 'stage-form/link-already-answered',
    explanation:
      'O link para o formulário da etapa já foi respondido. Formulários só podem ser respondidos uma vez por link.',
    localizations: {},
    message: 'Este formulário já foi respondido.',
  },
  StageFormLinkNotFound: {
    code: 'stage-form/link-not-found',
    explanation: 'O link para o formulário da etapa não foi encontrado.',
    localizations: {},
    message: 'O link do formulário não foi encontrado.',
  },
  StageFormNotFound: {
    code: 'stage-form/not-found',
    explanation: 'O formulário da etapa que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'Formulário da etapa não encontrado.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'stage-form'>;
